<template>
  <div class="periodWork">
    <box :title="$t('functionality')">
      <div v-if="Object.keys(periodWork).length > 0" class="pa-2">
        <v-row class="ma-0">
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("RozKarKard") }}: </span
            ><span class="summary-value"
              >{{ periodWork.RozKarKard }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("SaatKarkard") }}: </span
            ><span class="summary-value"
              >{{ periodWork.SaatKarkard }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("EzafekariMojaz") }}: </span
            ><span class="summary-value"
              >{{ periodWork.EzafekariMojaz }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("KasreKar") }}: </span
            ><span class="summary-value"
              >{{ periodWork.KasreKar }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("MorakhasiEstehghaghi") }}: </span
            ><span class="summary-value"
              >{{ periodWork.MorakhasiEstehghaghi }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("MorakhasiBedoneHoghogh") }}: </span
            ><span class="summary-value"
              >{{ periodWork.MorakhasiBedoneHoghogh }}
            </span></v-col
          >
          <v-col cols="6" sm="4" md="3" lg="3">
            <span>{{ $t("MISSION") }}: </span
            ><span class="summary-value"
              >{{ periodWork.Mamoriat }}
            </span></v-col
          >
        </v-row>
        <v-card-actions>
          <span></span>
          <v-spacer></v-spacer>
          <v-btn class="" color="primary" @click="showDetails">
            {{ $t("showDetails") }}
          </v-btn>
        </v-card-actions>
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import EmptyList from "../../widget/EmptyList.vue";
export default {
  components: { EmptyList },
  props: {
    periodWork: Object,
  },
  methods: {
    showDetails() {
      if (this.periodWork.isPeriod) {
        this.$router.push({
          name: "PeriodWorkDetails",
          params: {
            period: this.periodWork.period,
            year: this.periodWork.year,
          },
        });
      } else {
        this.$router.push({
          name: "MonthWorkDetails",
          params: {
            month: this.periodWork.period,
            year: this.periodWork.year,
          },
        });
      }
    },
  },
};
</script>

<style>
.summary-value {
  color: var(--border-green) !important;
}
</style>